var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.4561 9.07903c-.161-.59515-.4751-1.13771-.9111-1.57368-.436-.43596-.9785-.75011-1.5737-.91115-2.1787-.5942-10.9476-.5942-10.9476-.5942s-8.76896.01801-10.94769.6122c-.59514.16105-1.13771.47519-1.57367.91116-.43597.43596-.75011.97853-.91116 1.57367-.65902 3.87127-.9147 9.77007.01801 13.48647.16104.5952.47519 1.1377.91115 1.5737.43597.436.97854.7501 1.57368.9112 2.17872.5942 10.94768.5942 10.94768.5942s8.7689 0 10.9476-.5942c.5952-.1611 1.1377-.4752 1.5737-.9112s.7501-.9785.9111-1.5737c.6951-3.8767.9093-9.7718-.018-13.50447z",
    fill: "#8d7fac"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.2329 20.0445 7.2744-4.2134-7.2744-4.2134z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIconGray);
export default __webpack_public_path__ + "static/media/youtubeIconGray.65b4ecfb7f4024001890607477638940.svg";
export { ForwardRef as ReactComponent };